import { Expose } from 'class-transformer';

export class LanguageDto {
  @Expose()
  id: number;

  @Expose()
  uuid: string;

  @Expose()
  name: string;

  @Expose()
  alias: string;

  @Expose()
  createdAt: string;

  @Expose()
  updatedAt: string;
}
